import { ApiService } from "@core/api/api-service";
import { LegalDocumentsMetadata, LegalDocument } from "@domain/legal-content/legal-content";

export class LegalContentService {
	constructor(private readonly apiService: ApiService, private readonly unauthenticatedApiService: ApiService) {}

	async getTermsOfUse(locale: string): Promise<LegalDocument> {
		const result = await this.apiService.get<LegalDocument>("/legal-content/terms-of-use", { params: { locale } });
		return result.data;
	}

	async getPrivacyNotice(locale: string): Promise<LegalDocument> {
		const result = await this.apiService.get<LegalDocument>("/legal-content/privacy-notice", { params: { locale } });
		return result.data;
	}

	async getLegalDocumentsMetadata(): Promise<LegalDocumentsMetadata> {
		const result = await this.unauthenticatedApiService.get<LegalDocumentsMetadata>("/legal-content/documents-metadata");
		return result.data;
	}

	async consentToLegalDocuments(termsOfUseVersion: number, privacyNoticeVersion: number): Promise<void> {
		await this.apiService.post<LegalDocument>("/legal-content/consent", {
			touVersion: termsOfUseVersion,
			pnVersion: privacyNoticeVersion,
		});
	}
}
